import { Component, Input } from '@angular/core';
import LoggedAction from 'src/app/model/logged-action';
import { StringHelper } from 'src/app/helpers/string-helper';
import DateHelper from 'src/app/helpers/date-helper';

@Component({
  selector: 'logged-action-display',
  templateUrl: 'logged-action-display.component.html',
  styleUrls: ['logged-action-display.component.scss']
})
export class LoggedActionDisplayComponent {
  @Input()
  inputLoggedAction: LoggedAction;

  printUser() {
    if (this.inputLoggedAction.by == null) {
      return 'Geen gebruiker opgegeven';
    }
    return StringHelper.join(
      [
        this.inputLoggedAction.by.firstName == null
          ? ''
          : this.inputLoggedAction.by.firstName.toString(),
        this.inputLoggedAction.by.lastName == null
          ? ''
          : this.inputLoggedAction.by.lastName.toString()
      ],
      ' '
    );
  }

  printDate() {
    if (this.inputLoggedAction.date == null) {
      return 'Geen datum opgegeven';
    }
    return DateHelper.formatDateTime(this.inputLoggedAction.date);
  }
}
